module.exports = ".capacityExplanations {\n  font-size: 10px;\n}\n\n\n.NotBlendMember {\n  color: #b36800;\n}\n\n\n.BlendMember {\n  color: #618d35;\n}\n\n\n#supplierTable {\n  font-size:x-small;\n}\n\n\n.container\n{\n  margin-left:calc(1%);\n}\n\n\n#popupMessage {\n  padding: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/feasibility-response/feasibility-response.component.css
// module id = ./src/app/components/feasibility-response/feasibility-response.component.css
// module chunks = main